import moment from 'moment'
import Dates from './assets/DataKey/dates.svg'
import Prize from './assets/DataKey/prize.svg'
import Registrations from './assets/DataKey/registrations.svg'
import UsDollarCircled from './assets/DataKey/usDollarCircled.svg'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { CONST } from '../../../../const/const'
import FirestoreService from '../../../../services/firestoreService'
import { ISelectedEvent } from '../../../../store/events/eventsSlice'
import { EventModel } from '../../../../models/events/event.model'
import { validateOldTags } from '../../../../helpers/validateOldTags'
import { getFloatPrice } from '../../../../helpers/price'
import { getAllRegistrationFees } from '../../../../helpers/registrationFees'
import { getCurrency } from '../../../../helpers/payment'

export const EventDetailViewComponentDataKeyElement: React.FC<{
  logo: any
  title: string
  row1: Array<string | Date | undefined | Array<string>>
  row2?: Array<string | Date | undefined> | undefined
}> = ({ logo, title, row1, row2 }) => {
  const rows = {
    row1: Array.isArray(row1[1])
      ? validateOldTags(row1[1]).join(', ')
      : ((typeof row1[1] === 'object'
          ? new Date(
              (row1[1] as unknown as { nanoseconds: string })?.nanoseconds
            ).toLocaleDateString()
          : row1[1]) ?? 'unknown'),
    ...(row2 && {
      row2:
        (typeof row2[1] === 'object'
          ? new Date(
              (row2[1] as unknown as { nanoseconds: string })?.nanoseconds
            ).toLocaleDateString()
          : row2[1]) ?? 'unknown',
    }),
  }

  return (
    <div className="border border-[#D3DAEE] rounded-lg p-4 2xl:p-5">
      <div className="flex items-center gap-2 flex-wrap mb-2">
        <img src={logo} alt="logo" />
        <h3 className="text-base 2xl:text-lg font-bold text-SeabiscuitDark200ThemeColor">
          {title}
        </h3>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-[150px_auto] gap-1 justify-between">
        <div className="text-nr 2xl:text-base text-SeabiscuitDark200ThemeColor opacity-70 font-semibold">
          {row1[0]?.toString()}:
        </div>
        <div
          title={rows.row1.includes('All') ? 'All' : rows.row1}
          className="truncate text-nr 2xl:text-base text-SeabiscuitDark200ThemeColor opacity-70 xl:text-right"
        >
          {rows.row1.includes('All') ? 'All' : rows.row1}
        </div>
        {rows?.row2 && rows.row2 !== '' && row2 ? (
          <>
            <div className="text-nr 2xl:text-base text-SeabiscuitDark200ThemeColor opacity-70 font-semibold">
              {row2[0]?.toString()}:
            </div>
            <div
              title={rows.row2}
              className="text-nr 2xl:text-base text-SeabiscuitDark200ThemeColor opacity-70 truncate xl:text-right"
            >
              {rows.row2}
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}

const EventDetailsViewComponentDataKey: React.FC<{
  selectedEvent: ISelectedEvent
}> = ({ selectedEvent }) => {
  const getEventLocation = (): string => {
    let separator = ''
    let valueToReturn = ''
    let details = selectedEvent?.EventDetails ?? {}

    if (details) {
      if (details?.competitionCity && details.competitionCity !== '') {
        valueToReturn += details.competitionCity
        separator = ', '
      } else separator = ''

      if (details?.competitionState && details.competitionState !== '') {
        valueToReturn += separator + details.competitionState
        separator = ', '
      } else separator = ''

      if (details?.competitionCountry && details.competitionCountry !== '') {
        valueToReturn += separator + details.competitionCountry
      }
    }

    return valueToReturn
  }
  const params = useParams()

  const eventLocation = getEventLocation()
  const [tags, setTags] = useState<string[]>([])
  const handlegetevent = async (eventId: any) => {
    if (eventId) {
      const eventSnapshot = await FirestoreService.getItem(
        CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.EVENTS.NAME,
        eventId
      )

      if (eventSnapshot.exists()) {
        const event = EventModel.fromFirestoreDoc(eventSnapshot).toObject()
        setTags(event.tags)
      }
    }
  }

  useEffect(() => {
    if (params) {
      if ('eventId' in params) {
        if (params.eventId) {
          handlegetevent(params.eventId)
        }
      }
    }
  }, [params])
  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

  if (Object.keys(selectedEvent?.EventDetails ?? {}).length) {
    let compStartDate = new Date(selectedEvent.EventDetails?.competitionStartDate ?? '')
    let compEndDate = new Date(selectedEvent.EventDetails?.competitionEndDate ?? '')
    let dateStart = `${moment(selectedEvent.EventDetails?.competitionRegistrationOpenDate).format('MMM D,')} ${selectedEvent.EventDetails?.competitionRegistrationOpenTime ? Number((selectedEvent.EventDetails?.competitionRegistrationOpenTime as any)?.hour) : null}${selectedEvent.EventDetails?.competitionRegistrationOpenTime ? `:${(selectedEvent.EventDetails?.competitionRegistrationOpenTime as any)?.minutes}` : null} ${selectedEvent.EventDetails?.competitionRegistrationOpenTime ? (selectedEvent.EventDetails?.competitionRegistrationOpenTime as any)?.format : null}`
    let dateEnd = `${moment(selectedEvent.EventDetails?.competitionRegistrationCloseDate).format('MMM D,')} ${selectedEvent.EventDetails?.competitionRegistrationCloseTime ? Number((selectedEvent.EventDetails?.competitionRegistrationCloseTime as any)?.hour) : null}${selectedEvent.EventDetails?.competitionRegistrationCloseTime ? `:${(selectedEvent.EventDetails?.competitionRegistrationCloseTime as any)?.minutes}` : null} ${selectedEvent.EventDetails?.competitionRegistrationCloseTime ? (selectedEvent.EventDetails?.competitionRegistrationCloseTime as any)?.format : null}`

    const currency = getCurrency(selectedEvent.EventPaymentSettings?.currency)

    const ticketsCosts =
      selectedEvent?.EventTickets?.tickets?.map((ticket) => ticket.cost ?? 0) ?? []
    const ticketsMin = getFloatPrice(`${currency}${Math.min(...ticketsCosts)}`)
    const ticketsMax = getFloatPrice(`${currency}${Math.max(...ticketsCosts)}`)

    const allEntries =
      getAllRegistrationFees(selectedEvent?.EventFees?.registrationFees ?? []) ?? []
    const entriesCosts = allEntries?.map((entry) => entry.cost ?? 0) ?? []
    const entriesMin = getFloatPrice(`${currency}${Math.min(...entriesCosts)}`)
    const entriesMax = getFloatPrice(`${currency}${Math.max(...entriesCosts)}`)

    return (
      <div className="grid grid-2 md:grid-cols-2 gap-2">
        <EventDetailViewComponentDataKeyElement
          logo={Prize}
          title="Event type"
          row1={['Discipline', tags ?? []]}
          row2={['Location', eventLocation]}
        />

        <EventDetailViewComponentDataKeyElement
          logo={UsDollarCircled}
          title="Prices"
          row1={
            allEntries?.[0]
              ? entriesMin === entriesMax
                ? ['Classes', entriesMin || `${currency}0`]
                : ['Classes', `${entriesMin} - ${entriesMax}` || `${currency}0`]
              : ['Classes', 'None']
          }
          row2={
            selectedEvent?.EventTickets?.tickets?.[0] &&
            selectedEvent?.EventTickets?.sellSpectatorTickets
              ? ticketsMin === ticketsMax
                ? ['Spectator tix', ticketsMin || `${currency}0`]
                : ['Spectator tix', `${ticketsMin} - ${ticketsMax}` || `${currency}0`]
              : ['Spectator tix', 'Not for sale']
          }
        />

        <EventDetailViewComponentDataKeyElement
          logo={Dates}
          title="Dates"
          row1={[
            'Start',
            selectedEvent.EventDetails?.competitionStartDate
              ? moment(compStartDate).format('MMM D, YYYY')
              : '',
          ]}
          row2={[
            'End',
            selectedEvent.EventDetails?.competitionEndDate
              ? moment(compEndDate).format('MMM D, YYYY')
              : '',
          ]}
        />
        <EventDetailViewComponentDataKeyElement
          logo={Registrations}
          title="Registrations"
          row1={['Open', dateStart]}
          row2={['Close', dateEnd]}
        />
      </div>
    )
  } else {
    return <></>
  }
}
export default EventDetailsViewComponentDataKey
